import Move from './move';
export default Move;
